export const ROLE_HIERARCHY = 'role-hierarchy';
export const PROFILE = 'profile';
export const JOB_TYPE = 'job-type';
export const ROLE_HIERARCHY_ID = 3
export const RPROFILE_ID = 2;
export const JOB_TYPE_ID = 1;


export const PROFILE_PERMISION:{
    CRM:string;
    FSM:string;
    User:string;
    Finance:string;
    Inventory:string;
    Configuration:string;
    CompanyAndLocation:string;
    Miscellaneous:string;
    Others:string;
} = {
    CRM:'CRM',
    FSM:'FSM',
    User:'User',
    Finance:'Finance',
    Inventory:'Inventory',
    Configuration:'Configuration',
    CompanyAndLocation:'Company And Location',
    Miscellaneous:'Miscellaneous',
    Others:'Others',
}